<template>
<v-card flat>

  <member-actions-toolbar
    icon="mdi-star"
    title="Appointment Types"
    :practitioner="practitioner"
    :member.sync="member"
    @close="$emit('close')" />

  <v-divider/>

  <appointment-types-page
    v-if="member && member.id"
    :space-id="member.service"
    :member="practitioner" />
  <div v-else class="text-h6 pa-4" >
    <v-icon>mdi-information</v-icon>
    Choose a space above to edit {{fullName}}'s appointment types at that space
  </div>

</v-card>
</template>
<script>
import AppointmentTypesPage from '@/views/space/AppointmentTypesPage.vue'
import MemberActionsToolbar from './MemberActionsToolbar.vue'

export default {
  name: 'MemberAppointmentTypes',
  components: {
    AppointmentTypesPage,
    MemberActionsToolbar
  },
  props: {
    practitioner: { type: Object }
  },
  data () {
    return {
      member: null
    }
  }
}
</script>
